// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotShiphandlingNote\ApiPilotShiphandlingNote.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// PilotShiphandlingNoteData is the class that PilotShiphandlingNote serializes to/from
export interface PilotShiphandlingNoteData {
    Id : number;
	
    Event : EventData | null;
    EventId : number;
    Noter : PCUserData | null;
    NoterId : number;
    Vessel : VesselData | null;
    VesselId : number;
	
    Message : string | null;
}

// PilotShiphandlingNoteOptions is the class which may be passed to the PilotShiphandlingNote constructor to define optional initial data values
export interface PilotShiphandlingNoteOptions {
    Id : number;
	
    Event? : EventOptions | null;
    EventId? : number;
    Noter? : PCUserOptions | null;
    NoterId? : number;
    Vessel? : VesselOptions | null;
    VesselId? : number;
	
    Message? : string | null;
}

export class PilotShiphandlingNote {
    public Id : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public Noter : DataSignal<PCUser | null>;
    public NoterId : DataSignal<number>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number>;
	
    public Message : DataSignal<string | null>;

    constructor();
    constructor(data : PilotShiphandlingNoteOptions);
    constructor(data: PilotShiphandlingNoteOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.Noter = S.value<PCUser | null>(null);
        this.NoterId = jsonableObservable(S.value<number>(data && data.NoterId !== undefined ? data.NoterId : 0));
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.Message = jsonableObservable(S.value<string | null>(data && data.Message !== undefined ? data.Message : null));
    }

    static key(obj : PilotShiphandlingNote) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotShiphandlingNoteOptions) {
        return obj.Id;
    }

    static update(obj : PilotShiphandlingNote, data : PilotShiphandlingNoteOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.NoterId !== undefined) obj.NoterId(data.NoterId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.Message !== undefined) obj.Message(data.Message);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotShiphandlingNote.ts